import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, ChevronDown, Check } from 'lucide-react';
import { languages } from '../i18n';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-emerald-50 hover:bg-emerald-100 text-emerald-800 transition-colors"
        data-testid="language-switcher-btn"
      >
        <Globe size={18} />
        <span className="text-sm font-medium">{currentLang.flag} {currentLang.name}</span>
        <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          />
          <div 
            className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50"
            data-testid="language-dropdown"
          >
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => handleLanguageChange(lang.code)}
                className={`w-full px-4 py-2.5 text-left flex items-center justify-between hover:bg-emerald-50 transition-colors ${
                  i18n.language === lang.code ? 'bg-emerald-50 text-emerald-700' : 'text-gray-700'
                }`}
                data-testid={`lang-option-${lang.code}`}
              >
                <span className="flex items-center space-x-2">
                  <span>{lang.flag}</span>
                  <span className="text-sm font-medium">{lang.name}</span>
                </span>
                {i18n.language === lang.code && (
                  <Check size={16} className="text-emerald-600" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
